import { queryCache, useQuery, QueryStatus } from "react-query";
import {
  listCateringRecipesByBranch,
  listCateringRecipesByBusinessUnit,
} from "api/CateringRecipeApi";
import { BusniessUnit } from "types/Branch";
import { ICateringRecipe } from "types/CateringRecipe";

export const invalidateCateringRecipesCache = () => {
  queryCache.invalidateQueries("cateringRecipesByBranch");
};

interface IQueryCateringRecipesByBranch {
  status: QueryStatus;
  recipes: ICateringRecipe[];
  isFetching: boolean;
}

// Resolves the branch's business unit on the server and returns its catering recipes.
// If the branch's businessUnit is known on the client (populated on the Branch model),
// we use the ?businessUnit= variant as a fallback — useful while the by-branch route
// is not yet deployed.
export const useQueryCateringRecipesByBranch = (
  branchId: string | undefined,
  fallbackBusinessUnit?: BusniessUnit
): IQueryCateringRecipesByBranch => {
  const { status, data, isFetching } = useQuery(
    ["cateringRecipesByBranch", branchId ?? "", fallbackBusinessUnit ?? ""],
    async () => {
      if (!branchId) return [];
      const direct = await listCateringRecipesByBranch(branchId);
      if (direct !== null) return direct;
      if (fallbackBusinessUnit) {
        return await listCateringRecipesByBusinessUnit(fallbackBusinessUnit);
      }
      return [];
    },
    { enabled: !!branchId }
  );

  return {
    status,
    recipes: data ?? [],
    isFetching,
  };
};
